"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _nosherylogo = require("./nosherylogo.png");

var _nosherylogo2 = _interopRequireDefault(_nosherylogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const NosheryLogo = _styledComponents2.default.img.withConfig({
  displayName: "Logo__NosheryLogo",
  componentId: "sc-1elgvpu-0"
})(["width:", ";margin:0;padding:0;overflow:hidden;background-size:contain;background-position:center center;background-repeat:no-repeat;"], p => p.width);

const Logo = ({ width }) => {
  return _react2.default.createElement(NosheryLogo, { src: _nosherylogo2.default, width: width });
};

Logo.defaultProps = {
  width: "180px"
};

exports.default = Logo;